import moment from "moment";

const state = {
    loading: false,
    isBusinessUnitPanelVisible: false,
    isDateTimePanelVisible: false,
    // date panel visible tab
    dateTabItem: 0,
    isFiltersPanelVisible: false,
    alias: [],
    searchQueryStr: "",
    isDirtySearch: false,
    beginDate: moment().subtract(1, 'days'),
    endDate: moment(),
    filters: [],
    poslogs: [],
    nbMaxPoslogs: 0,
    poslogsTableOptions: {
        page: 1, // start to 1, not 0, follow vuetify datable
        itemsPerPage: 10,
        sortBy: ["createdAt"],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
    }
};

export default state;
